import { Navigate, Outlet } from "react-router-dom";
import { formatPermissions } from "../../../helper/auth";
import Error404 from "../../../feature-module/pages/error/error-404";

import { usePermissions } from "../context/PermissionsUserContext";
import { useDispatch, useSelector } from "react-redux";
import { loadUserDataThunk } from "../../data/redux/authSlice";
import { useEffect } from "react";
import { AppDispatch } from "../../data/redux/store";
import { getUserPermissionsLabel } from "../../../api/permissions";

interface Props {
  requiredPermissions?: string[];
}

const ProtectedRouteWithPermission = ({ requiredPermissions }: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const isAuth = useSelector((state: any) => state.auth.isAuthenticated);
  const isSuperAdmin = useSelector(
    (state: any) => state.auth.user?.isSuperAdmin,
  );
  const userType = useSelector((state: any) => state.auth.userType);

  const { permissions, setPermissions, isLoading, setIsLoading } =
    usePermissions();

  useEffect(() => {
    const init = async () => {
      try {
        if (!isAuth) {
          await dispatch(loadUserDataThunk()).unwrap();
        }

        if (permissions.length === 0 && userType === "UserProfil") {
          const resp = await getUserPermissionsLabel();
          const formatted = resp?.data
            ? formatPermissions(resp.data?.permissionsByFunctionality)
            : [];
          setPermissions(formatted || []);
        }
      } catch (error) {
        // console.error("Erreur de chargement initial", error);
      } finally {
        setIsLoading(false);
      }
    };

    init();
  }, [isAuth, dispatch]);

  // S’il est en cours de chargement, ne rien rendre (ou un spinner)
  if (isLoading) return null; // ou <LoadingSpinner />

  // s'il n'est pas connecter, le redirectionner
  if (!isAuth) return <Navigate to="/login" replace />;

  if (
    requiredPermissions &&
    requiredPermissions.length > 0 &&
    !isSuperAdmin && //donner l'accès si la personne est superAdmin
    (!permissions ||
      !requiredPermissions.some((perm) => permissions.includes(perm)))
  ) {
    return <Error404 />;
  }

  return <Outlet />;
};

export default ProtectedRouteWithPermission;
